export default __webpack_public_path__ + "static/location-weather-chart-phuket-851eed55dc430bb6a15d7ff366bda744.svg";